<template>
    <v-container>
        <div v-if="mustShowFareExpirationDateMassUpdateButton" class="d-flex">
            <v-btn
                color="primary"
                class="ms-auto mb-6"
                @click="openFareExpirationDateMassUpdateModal()"
            >
                <v-icon class="mr-2">mdi-update</v-icon>Atualização de validade em massa
            </v-btn>
        </div>
        <room
            v-on:removeRoom="removeRoom"
            v-for="room in rooms"
            ref="rooms"
            :roomIndex="room.key"
            :key="room.key"
            :hotelRoom=" hotelRooms !== null && hotelRooms[room.key - 1] !== undefined ? hotelRooms[room.key - 1] : null"
        />
        <v-row>
            <v-col cols="12" md="6">
                <v-btn
                    depressed
                    color="primary"
                    @click="addRoom"
                    class="w-100"
                >
                    Adicionar Quarto
                </v-btn>
            </v-col>
            <v-col cols="12" md="6">
                <v-btn
                    depressed
                    color="success"
                    @click="validate"
                    class="w-100"
                >
                    Proximo
                </v-btn>
            </v-col>
        </v-row>
        <fare-expiration-date-mass-update-dialog
            :model.sync="fareExpirationDateMassUpdateModal.model"
            :execute-mass-update="fareExpirationDateMassUpdateModal.executeMassUpdate"
            @open-mass-update-confirmation-modal="openMassUpdateConfirmationModal()"
            @got-mass-update-response="setMassUpdateResponseModalData"
        />
        <confirm-action-dialog
            title="Atualizar Tarifas em Massa"
            type="warning"
            action-button-label="Atualizar"
            :model.sync="massUpdateConfirmationModal.model"
            :message="massUpdateConfirmationModal.message"
            @confirm="massUpdateFareExpirationDate()"
        />
        <response-dialog
            :model.sync="massUpdateConfirmationModal.responseModel"
            :type="massUpdateConfirmationModal.responseType"
            :message="massUpdateConfirmationModal.responseMessage"
            @close="reloadPage()"
        />
    </v-container>
</template>

<script>
import Room from "./Room.vue";
import RoundedDialog from "../../Dialog/RoundedDialog.vue";
import FareExpirationDateMassUpdateDialog from "../../Dialog/FareExpirationDateMassUpdateDialog.vue";
import ConfirmActionDialog from "../../Dialog/ConfirmActionDialog.vue";
import ResponseDialog from "../../Dialog/ResponseDialog.vue";

export default {
    name: "Rooms",
    components: {
        ResponseDialog, ConfirmActionDialog,
        FareExpirationDateMassUpdateDialog,
        RoundedDialog,
        Room
    },
    props: {
        hotelRooms: {
            type: Array,
            default: null
        },
    },
    data: () => ({
        valid: false,
        rooms: [{
            key: 1
        }],
        fareExpirationDateMassUpdateModal: {
            model: false,
            executeMassUpdate: false,
        },
        massUpdateConfirmationModal: {
            model: false,
            message: 'Tem certeza que deseja atualizar todas as tarifas selecionadas?',
            responseModel: false,
            responseType: null,
            responseMessage: ''
        }
    }),
    computed: {
        mustShowFareExpirationDateMassUpdateButton () {
            return this.$can('change.fare-expiration-date') && this.isEditingHotel;
        },
        isEditingHotel () {
            return this.hotelRooms !== undefined &&
                this.hotelRooms !== null &&
                this.hotelRooms.length &&
                this.hotelRooms[0].hasOwnProperty('id');
        }
    },
    methods: {
        getData() {
            return this.$refs.rooms.map(room => {
                return room.getData();
            });
        },
        setData() {
            for(let i = 1; i < this.hotelRooms.length; i++){
                this.addRoom();
            }
        },
        addRoom() {
            let lastKey = this.rooms[this.rooms.length - 1].key;
            this.rooms.push({
                key: lastKey + 1
            })
        },
        removeRoom(key) {
            let indexOf = this.rooms.findIndex(room => {
                return room.key === key;
            });
            this.rooms.splice(indexOf, 1);
            this.hotelRooms.splice(indexOf, 1);
        },
        validate() {
            let valid = true;
            this.$refs.rooms.forEach(room => {
                room.validate();
                if (!room.$data.valid) {
                    valid = false;
                }
            });
            this.valid = valid;
            if(valid) {
                this.$emit('goToTab', 'images');
            }
        },
        openFareExpirationDateMassUpdateModal () {
            this.fareExpirationDateMassUpdateModal.model = true;
        },
        openMassUpdateConfirmationModal () {
            this.massUpdateConfirmationModal.model = true;
        },
        massUpdateFareExpirationDate () {
            this.fareExpirationDateMassUpdateModal.executeMassUpdate = true;
        },
        setMassUpdateResponseModalData (responseData) {
            this.massUpdateConfirmationModal.model = false;
            this.massUpdateConfirmationModal.responseType = responseData.type;
            this.massUpdateConfirmationModal.responseMessage = responseData.message;
            this.massUpdateConfirmationModal.responseModel = true;
        },
        reloadPage () {
            window.location.reload();
            this.$forceUpdate();
        }
    },
    created() {
        if(this.hotelRooms !== null){
            this.setData();
        }
    }
}
</script>

<style scoped>

</style>
